import React, { Component } from 'react';
import autoBind from 'react-autobind';

import navbarActions from '@common/store/navbar/navbar.actions';
import navbarSelectors from '@common/store/navbar/navbar.selectors';

import { connect } from '@common/components/base.component';

import localStorageUtils from '@common/helpers/localStorage.utils';

import NavbarChangeTheme from './changeTheme/navbar.changeTheme';
import NavbarChangePassword from './changePassword/navbar.changePassword';
import NavbarNotification from '../notification/navbar.notification';
import NavbarAbout from './about/navbar.about';

class NavbarUser extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      showChangeThemeModal: false,
      showChangePasswordModal: false,
      showAboutModal: false,
    };
  }

  getUser() {
    const sessionsInfo = localStorageUtils.getItem('SESSION_INFO_STORAGE_KEY');
    return sessionsInfo?.userId;
  }

  changeTheme() {
    this.setState({ showChangeThemeModal: true });
  }

  changePassword() {
    this.setState({ showChangePasswordModal: true });
  }

  onClose() {
    this.setState({ showChangeThemeModal: false, showChangePasswordModal: false, showAboutModal: false });
  }

  suport() {
    this.props.routerManager.redirect({ name: 'suporte.manual' });
  }

  refreshPerfisAcesso() {
    this.props.navbarActions.getMenuByPermissions(this.getUser());
  }

  about() {
    this.setState({ showAboutModal: true });
  }

  logOut() {
    let session = localStorageUtils.getSession();
    const refreshToken = session.refreshToken;
    this.props.navbarActions.logout(refreshToken);

    setTimeout(() => {
      localStorageUtils.destroy();

      const host = window.location.host;
      window.location.href = `http://${host}/#/login`;
    }, 300);
  }

  render() {
    const { showChangeThemeModal, showChangePasswordModal, showAboutModal } = this.state;
    const { user } = this.props.navbarSelectors;
    const { totalNotification } = this.props.navbarSelectors;
    const color = { color: 'white' };

    return (
      <div className="user-container">
        <NavbarChangeTheme showChangeThemeModal={showChangeThemeModal} onClose={this.onClose} />
        <NavbarChangePassword showChangePasswordModal={showChangePasswordModal} onClose={this.onClose} />
        <NavbarAbout showAboutModal={showAboutModal} onClose={this.onClose} />
        <div className="user-content">
          <i className="fa fa-user" />
          {totalNotification > 0 ? (
            <a>
              <span className="badge notification" style={color}>
                {totalNotification}
              </span>
            </a>
          ) : null}

          <div className="user-info">
            <h3>{this.getUser()}</h3>
            <ul>
              <li>
                <h5 className="info">
                  <strong>Último Acesso:</strong> {user.DataHoraEvento}
                </h5>
              </li>
              <li>
                <h5 className="info">
                  <strong>IP:</strong> {user.IpRemoto}
                </h5>
              </li>

              <NavbarNotification />

              <li onClick={this.changeTheme}>
                <i className="fa fa-paint-brush" />
                <a className="pointer-events-none">Alterar Tema</a>
              </li>
              <li onClick={this.changePassword}>
                <i className="fa fa-key" />
                <a className="pointer-events-none">Alterar Senha</a>
              </li>
              <li onClick={this.suport}>
                <i className="fa fa-book" />
                <a className="pointer-events-none">Suporte</a>
              </li>
              <li onClick={this.refreshPerfisAcesso}>
                <i className="fas fa-sync" />
                <a className="pointer-events-none">Atualizar Permissões</a>
              </li>
              <li onClick={this.about}>
                <i className="fas fa-info-circle" />
                <a className="pointer-events-none">Sobre</a>
              </li>
            </ul>
            <p className="text-right">
              <button className="btn btn-link btn-user-logout" onClick={this.logOut}>
                <i className="fa fa-sign-out-alt" /> Sair
              </button>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default connect({
  selectors: {
    navbarSelectors,
  },
  actions: {
    navbarActions,
  },
})(NavbarUser);
